import React from 'react';
import { Box, ListItemButton, ListItemText, ListItemIcon, useTheme } from '@mui/material';
import { Link } from 'react-router-dom';
import { useMenuContext } from '../../context/MenuContext';
import { childDotSx, childSx } from './navStyles';

// `open` is set when the item is a child row inside an expanded branch.
const NavItem = ({ item, open }) => {
  const theme = useTheme();
  const { selectedMenuItem } = useMenuContext();

  const isSelected = item.id === selectedMenuItem;
  // Navigation is a plain link to the section URL; MenuContext derives the
  // selected item from it. `replace` on the current item avoids stacking
  // duplicate history entries when re-clicking the open section.
  if (open) {
    return (
      <ListItemButton
        component={Link}
        to={`/dashboard/${item.id}`}
        replace={isSelected}
        aria-current={isSelected ? 'page' : undefined}
        sx={childSx(theme, isSelected)}
      >
        <ListItemIcon>
          {item.icon || <Box component="span" sx={childDotSx(theme, isSelected)} />}
        </ListItemIcon>
        <ListItemText primary={item.title} />
      </ListItemButton>
    );
  }

  return (
    <ListItemButton
      component={Link}
      to={`/dashboard/${item.id}`}
      replace={isSelected}
      sx={navItemStyles(theme, isSelected)}
    >
      <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
        <ListItemText primary={item.title}
          sx={{
            flexGrow: 1,
            textAlign: 'right',
            color: theme.palette.text.default,
          }} />
        {item.icon && <ListItemIcon sx={{ color: theme.palette.text.default }}>{item.icon}</ListItemIcon>}
      </div>
    </ListItemButton>
  );
};

export default NavItem;

const navItemStyles = (theme, isSelected) => ({
  height: '3rem',
  py: '0.5rem',
  '&:hover': {
    backgroundColor: theme.palette.button.active,
    '& .MuiListItemText-root': {
      color: theme.palette.text.active,
    },
    '& .MuiListItemIcon-root': {
      color: theme.palette.text.active,
    },
  },
  pr: '1rem',
  '& .MuiListItemIcon-root': {
    minWidth: '0px',
    marginLeft: '0px'
  },
  '& .MuiListItemText-root': {
    margin: '0',
  },
  '& .MuiListItemText-primary': {
    fontWeight: isSelected ? 'bold' : 'normal',
    color: isSelected ? theme.palette.text.active : theme.palette.text.default,
  },
  display: 'flex',
  justifyContent: 'flex-end',
  width: '100%',
  borderRadius: '0.8rem',
});
